import { Button, Flex, Text, Container } from '@mantine/core';
import { IconCheck, IconEdit, IconPlus } from '@tabler/icons-react';
import React, { useState, useEffect } from 'react';
import DiscoveryManager from './DiscoveryManager';
import InterestManager from './InterestManager';
import { theme } from '../consilitheme';
import {
  useCreateInterestMutation,
  useGetInterestsQuery,
  useUpdateInterestMutation,
} from '../endpoints/discovery';
import { useUserQuery } from '../endpoints/user';
import moment from 'moment';

const DiscoveryPanel = ({ setShowChatLogo, firstOpen, setFirstOpen }) => {
  const [discoveryItems, setDiscoveryItems] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [userId, setUserId] = useState(false);
  const [createInterestById] = useCreateInterestMutation();
  const user = useUserQuery();
  const { data: interestsData, isLoading: isInterestsLoading } =
    useGetInterestsQuery();
  const [updateInterestById] = useUpdateInterestMutation();

  useEffect(() => {
    setDiscoveryItems(interestsData);
  }, [interestsData]);

  useEffect(() => {
    setUserId(user.data ? user.data[0].id : null);
  }, [user]);

  const addNewInterest = () => {
    setDiscoveryItems([
      ...discoveryItems,
      {
        categories: [],
        sources: [],
        subject: '',
        id: moment().valueOf(),
        edit: true,
      },
    ]);
  };

  const handleDiscoveryClick = () => {
    setFirstOpen(false);
    setIsEditing(!isEditing);
    setShowChatLogo();
  };

  const updateEdit = (updatedInterest) => {
    return { ...updatedInterest, edit: !updatedInterest.edit };
  };

  const editInterest = async (itemId, updatedInterest) => {
    try {
      const updateResponse = await updateInterestById({
        ...updatedInterest,
        created: undefined,
        modified: undefined,
      });
      if (updateResponse.error) {
        const createResponse = await createInterestById({
          ...updatedInterest,
          owner: userId,
        });
        const newDiscoveryItems = discoveryItems.length
          ? discoveryItems.slice(0, -1)
          : discoveryItems;
        setDiscoveryItems([
          ...newDiscoveryItems,
          {
            ...createResponse.data,
            edit: false,
          },
        ]);
        return;
      }

      updatedInterest = updateEdit(updatedInterest);
      const newItems = discoveryItems.map((item) =>
        item.id === itemId ? updatedInterest : item
      );
      setDiscoveryItems(newItems);
    } catch (error) {
      console.error('Error creating interest:', error);
    }
  };
  return (
    <Container>
      <Flex align="center" mb={theme.padding.xs} pt={theme.padding.md}>
        <Text fw={700} className="panel-title" mb={theme.padding.sm}>
          Knowledge Discovery
        </Text>
        {isEditing && (
          <Button
            leftSection={<IconPlus size={14} />}
            size="xs"
            ml="auto"
            variant="default"
            onClick={addNewInterest}
          >
            Add Interest
          </Button>
        )}
        <Button
          leftSection={
            isEditing ? <IconCheck size={14} /> : <IconEdit size={14} />
          }
          ml={isEditing ? '5px' : 'auto'}
          size="xs"
          variant="default"
          onClick={handleDiscoveryClick}
        >
          {isEditing ? 'Save' : 'Edit'}
        </Button>
      </Flex>
      {isEditing ? (
        <InterestManager
          discoveryItems={discoveryItems}
          setDiscoveryItems={setDiscoveryItems}
          editInterest={(itemId, updatedInterest) =>
            editInterest(itemId, updatedInterest)
          }
          interestsData={interestsData}
          isInterestsLoading={isInterestsLoading}
        />
      ) : (
        <DiscoveryManager
          setIsEditing={setIsEditing}
          setShowChatLogo={setShowChatLogo}
          firstOpen={firstOpen}
          interestsData={interestsData}
          isInterestsLoading={isInterestsLoading}
        />
      )}
    </Container>
  );
};

export default DiscoveryPanel;
